export const GET_FILTER_LISTING = 'GET_FILTER_LISTING';
export const POST_RAW_CANDIDATE_SEARCH = 'POST_RAW_CANDIDATE_SEARCH';
export const POST_CANDIDATE_CREATE_GENERATE = 'POST_CANDIDATE_CREATE_GENERATE';
export const POST_CANDIDATE_CREATE_SEND_EMAIL = 'POST_CANDIDATE_CREATE_SEND_EMAIL';
export const POST_CANDIDATE_CREATE_CHECK_EMAIL_ELIGIBILITY = 'POST_CANDIDATE_CREATE_CHECK_EMAIL_ELIGIBILITY';
export const POST_CANDIDATE_CREATE_EXPORT_EXCEL = 'POST_CANDIDATE_CREATE_EXPORT_EXCEL';
export const GET_CANDIDATE_INFO_TO_BE_UPDATED = 'GET_CANDIDATE_INFO_TO_BE_UPDATED';
export const PUT_UPDATE_AUTHENTICATION_TYPE = 'PUT_UPDATE_AUTHENTICATION_TYPE';
